import useSWR from 'swr'
import { UserService } from '@forwardflow/services/UserService'

interface Calendar {
   id: string
   summary: string
}

export const useGetCalendarList = (shouldFetch: boolean) => {
   return useSWR<Calendar[]>(
      shouldFetch ? `/calendar/calendar-list-with-preference` : null,
      async () => {
         const response = await UserService.getCalendarList()
         return response
      },
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: false,
      }
   )
}
